import SchedulesList from './SchedulesList';
import type { Props as SchedulesListProps } from './types';

export default SchedulesList;
export type { SchedulesListProps };
